function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  fill: "#FC4F52",
  r: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.284 12.403h1.428l.378-4.788.07-2.086H8.836l.07 2.086.378 4.788zm.714 3.724c.7 0 1.232-.504 1.232-1.232 0-.742-.532-1.246-1.232-1.246s-1.232.504-1.232 1.246c0 .728.518 1.232 1.232 1.232z",
  fill: "#fff"
});

var SvgIconAlertExclamation = function SvgIconAlertExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjEwIiBjeT0iMTAiIHJ4PSIxMCIgcnk9IjEwIiBmaWxsPSIjRkM0RjUyIi8+CjxwYXRoIGQ9Ik05LjI4NDA1IDEyLjQwMjdIMTAuNzEyTDExLjA5IDcuNjE0NzNMMTEuMTYgNS41Mjg3M0g4LjgzNjA1TDguOTA2MDUgNy42MTQ3M0w5LjI4NDA1IDEyLjQwMjdaTTkuOTk4MDUgMTYuMTI2N0MxMC42OTggMTYuMTI2NyAxMS4yMyAxNS42MjI3IDExLjIzIDE0Ljg5NDdDMTEuMjMgMTQuMTUyNyAxMC42OTggMTMuNjQ4NyA5Ljk5ODA1IDEzLjY0ODdDOS4yOTgwNSAxMy42NDg3IDguNzY2MDUgMTQuMTUyNyA4Ljc2NjA1IDE0Ljg5NDdDOC43NjYwNSAxNS42MjI3IDkuMjg0MDUgMTYuMTI2NyA5Ljk5ODA1IDE2LjEyNjdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconAlertExclamation as ReactComponent };